import React from "react";
import { useSelector, useDispatch } from "react-redux";
import Modal from "../../../UIElements/Modal";
import * as actionCreator from "../../store/actions";
import { useTranslation } from "react-i18next";
import DashBorder from "../../../UIElements/DashBorder";
import Linkify from "linkify-react";
import { hitHapticFeedback } from "@src/utils";
import { hitDeeplinkExecutedV2 } from "@src/utils/hitDeeplink";
import { COMMON_DEEPLINK_ACTIONS } from "@src/utils/constants";

const AboutCourseBottomSheet = (props) => {
  const { t } = useTranslation();
  const state = useSelector(
    (state) => state?.bottomSheetReducer?.showAboutThisCourseBottomSheet
  );
  const descriptionContent = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course
  );
  // console.log(descriptionContent, "descriptionContent");
  const dispatch = useDispatch();

  const isPurchased = useSelector(state => state?.overviewReducer?.overViewDetails?.course?.metaData?.isPurchased);
  const offlineMaterialFlag = useSelector(state => state?.overviewReducer?.overViewDetails?.course?.metaData?.offlineMaterialFlag);

  const linkProps = {
    onClick: (e) => {
      e?.preventDefault();
      hitHapticFeedback();
      hitDeeplinkExecutedV2(
        JSON.stringify({
          screen: COMMON_DEEPLINK_ACTIONS.UTIL_BROWSER,
          paramOne: e?.nativeEvent?.target?.innerText,
        }),
        JSON.stringify({
          screen: COMMON_DEEPLINK_ACTIONS.UTIL_BROWSER,
          paramOne: e?.nativeEvent?.target?.innerText,
        })
      );
    },
  };

  return (
    <Modal
      showModal={state}
      handleClose={() => {
        dispatch(actionCreator.showAboutThisCourseBottomSheetAction(false));
      }}
      header={
        <div className="AboutCourseBottomSheet__TempModalComponentData__Head">
          {offlineMaterialFlag ? "About this Book" : t(
            "components.bottomSheets.components.aboutCourseBottomSheet.aboutThisCourse",
            "About this Course"
          )}
        </div>
      }
    >
      <div className="AboutCourseBottomSheet__TempModalComponentData">
        <div className="OverView__Heading__Left CourseName">
          {descriptionContent?.details?.name}
        </div>

        <section>
          <p className="OverView__Categories__text modal">
            {descriptionContent?.categoryList?.join(" • ")}
          </p>
        </section>
        <DashBorder />
        <section className="AboutCourseBottomSheet__TempModalComponentData__text">
          {isPurchased ? <Linkify options={{ attributes: linkProps }}>
            {descriptionContent?.details?.description}
          </Linkify> : descriptionContent?.details?.description}
        </section>
      </div>
    </Modal>
  );
};

export default AboutCourseBottomSheet;
